import { styled } from '../styling';

const Spacer = styled.hr`
  ${({ theme, withMargin }) =>
    `margin: ${withMargin ? theme.spacing.units(4) : '0'} 0`};
`;

export default Spacer;
